
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockEomProcessingGrid extends Serenity.EntityGrid<IcStockEomProcessingRow, any> {
        protected getColumnsKey() { return IcStockEomProcessingColumns.columnsKey; }
        protected getDialogType() { return IcStockEomProcessingDialog; }
        protected getIdProperty() { return IcStockEomProcessingRow.idProperty; }
        protected getInsertPermission() { return IcStockEomProcessingRow.insertPermission; }
        protected getLocalTextPrefix() { return IcStockEomProcessingRow.localTextPrefix; }
        protected getService() { return IcStockEomProcessingService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}